// eslint-disable-next-line no-unused-vars
export function determineCandlePatternTimeUnit(setupDetails) {
  return 'MINUTES';
}
